import axios from "axios";
export const BASE_URL = window['APP_API_URL'] || process.env.REACT_APP_API_URL;
export const AR_ENDPOINT = process.env.REACT_APP_AR_ENDPOINT;

const api = axios.create({
    baseURL: BASE_URL,
    timeout: 60000,
    // headers: {'X-Custom-Header': 'foobar'}
});


export async function createAr(json){

    return api.request({
        method: "post", 
        url: AR_ENDPOINT, 
        data: json, 
        headers: {
            'Content-Type': 'application/json'
        }
    });    
}

export async function getCategoriesTree(){

    return api.request({
        method: "get", 
        url: `${BASE_URL}categories`, 
        headers: {
            'Content-Type': 'application/json'
        }
    });    
}

export async function saveScreenshoot({base64, hash}){

    return api.request({
        method: "post", 
        url: `${BASE_URL}save-image`,
        data: {
            base64,
            hash
        },
        headers: {
            'Content-Type': 'application/json'
        }
    });    
}




